import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsRoutingModule } from './clients-routing.module';
import { ListeClientsComponent } from './components/liste-clients/liste-clients.component';
import { PrestationClientsComponent } from './components/prestation-clients/prestation-clients.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DetailsClientsComponent } from './components/liste-clients/details-clients/details-clients.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { RatingModule } from 'ngx-bootstrap/rating';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CalendarModule } from 'primeng/calendar';
import { FieldErrorModule } from '@shared/components/shared-field-error/field-error.module';
import { ConsultantclientComponent } from './components/consultantclient/consultantclient.component';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from 'app/shared/shared.module';
import { EditClientComponent } from './components/liste-clients/edit-client/edit-client.component';
import { AddClientComponent } from './components/liste-clients/add-client/add-client.component';
import { MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
  declarations: [
    ListeClientsComponent,
    PrestationClientsComponent,
    DetailsClientsComponent,
    ConsultantclientComponent,
    EditClientComponent,
    AddClientComponent,
  ],
  imports: [
    CommonModule,
    ClientsRoutingModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule,
    RatingModule.forRoot(),
    NgxSpinnerModule,
    NgxIntlTelInputModule,
    NgxIntlTelephoneInputModule,
    CalendarModule,
    FieldErrorModule,
    MatMenuModule,
    SharedModule,
    MatTooltipModule
  ],
})
export class ClientsModule {}
